import * as React from 'react';
export function useFocusGroupOptionController(props) {
  const {
    groups
  } = props;
  const [focusedIndex, setFocusedIndex] = React.useState({
    group: -1,
    option: -1
  });
  const moveFocus = React.useCallback(delta => {
    const group = groups[focusedIndex.group];
    if (!group) {
      return;
    }
    const groupsCount = groups.length;
    const optionsCount = group.options.length;
    const nextOptionIndex = focusedIndex.option + delta;
    const nextGroupIndex = focusedIndex.group + delta;
    if (nextOptionIndex < 0) {
      if (nextGroupIndex < 0) {
        return;
      }
      setFocusedIndex({
        group: nextGroupIndex,
        option: groups[nextGroupIndex].options.length - 1
      });
      return;
    }
    if (nextOptionIndex >= optionsCount) {
      if (nextGroupIndex >= groupsCount) {
        return;
      }
      setFocusedIndex({
        group: nextGroupIndex,
        option: 0
      });
      return;
    }
    setFocusedIndex({
      group: focusedIndex.group,
      option: nextOptionIndex
    });
  }, [groups, focusedIndex]);
  return {
    focusedIndex,
    actions: {
      moveFocus,
      setFocusedIndex
    }
  };
}